import { gql } from '@apollo/client';

export const ALL_USERS_QUERY_NAME = 'AllUsers';
export const ALL_USERS = gql`
    query ${ALL_USERS_QUERY_NAME}(
        $page: Int,
        $perPage: Int,
        $query: String,
        $includeDeactivated: Boolean,
        $usersWithoutMembersOnly: Boolean,
        $sortKey: String,
        $sortDirection: String,
        $valueMapping: Map_String_List_MappedValueScalar,
    ) {
        allUsers(
            page: $page,
            perPage: $perPage,
            query: $query,
            includeDeactivated: $includeDeactivated,
            usersWithoutMembersOnly: $usersWithoutMembersOnly,
            sortKey: $sortKey,
            sortDirection: $sortDirection,
            valueMapping: $valueMapping,
        ) {
            availableRoles {
                role
                isAssignable
                allowedMemberTypes
            },
            assignableMembers {
                memberType
                members {
                    name
                    memberId
                    balancingGroup
                    phone
                    emails
                }
            },
            availableForbiddenZones {
                code
                name
            },
            allowedRoleCombinations,
            clearingEnabled,
            userList {
                totalCount
                models {
                    id
                    racf
                    name
                    email
                    active
                    suspended
                    lastSigninTime
                }
            }
        }
    }
`;

export const USER_DETAIL_QUERY_NAME = 'UserDetail';
export const USER_DETAIL = gql`
    query ${USER_DETAIL_QUERY_NAME}(
        $id: Int!,
    ) {
        userDetail(
            id: $id,
        ) {
            id
            racf
            userCode
            name
            email
            roles
            active
            suspended
            phone
            address
            lastSigninTime
            passwordRetryCount
            activationBlockers
            deactivationBlockers
            modificationBlockers
            suspensionBlockers
            internal
            ldapStatuses {
                statusId
                params
            }
            members {
                name
                memberId
                balancingGroup
                phone
                emails
            }
            forbiddenZones {
                code
                name
            }
        }
    }
`;

export const UPDATE_USER = gql`
    mutation UpdateUser(
        $id: Int!,
        $racf: String, 
        $userCode: String
        $name: String, 
        $email: String, 
        $phone: String, 
        $address: String, 
        $roles: [UserRole],
        $memberIds: [String],
        $forbiddenZones: [String],
        $correlationId: String!,
        $fourEyesUserId: String, 
        $fourEyesPassword: String, 
        $extraConfirmation: Boolean = false,
    ) {
        updateUser(
            id: $id,
            racf: $racf, 
            userCode: $userCode,
            name: $name, 
            email: $email, 
            phone: $phone, 
            address: $address,
            roles: $roles,
            memberIds: $memberIds,
            forbiddenZones: $forbiddenZones,
            correlationId: $correlationId,
            fourEyesUserId: $fourEyesUserId, 
            fourEyesPassword: $fourEyesPassword, 
            extraConfirmation: $extraConfirmation,
        ) {
            racf
            name
        }
    }
`;

export const CREATE_USER = gql`
    mutation CreateUser(
        $racf: String!,
        $name: String!,
        $email: String!,
        $userCode: String,
        $phone: String,
        $address: String,
        $roles: [UserRole],
        $memberIds: [String],
        $forbiddenZones: [String],
        $fourEyesUserId: String,
        $fourEyesPassword: String,
        $correlationId: String!
    ) {
        createUser(
            racf: $racf,
            name: $name,
            email: $email,
            userCode: $userCode,
            phone: $phone,
            address: $address,
            roles: $roles,
            memberIds: $memberIds,
            forbiddenZones: $forbiddenZones,
            fourEyesUserId: $fourEyesUserId,
            fourEyesPassword: $fourEyesPassword,
            correlationId: $correlationId,
        ) {
            racf
            name
        }
    }
`;

export const USER_TOTP_QUERY_NAME = 'UserTotp';
export const USER_TOTP = gql`
    query ${USER_TOTP_QUERY_NAME}(
        $id: Int!,
    ) {
        userTotp(
            id: $id,
        ) {
            totp
            expiresSecondsSinceEpoch
        }
    }
`;

export const TOGGLE_USER_SUSPENSION = gql`
    mutation ToggleUserSuspension(
        $id: Int!,
        $correlationId: String!,
        $fourEyesUserId: String, 
        $fourEyesPassword: String, 
        $extraConfirmation: Boolean = false,
    ) {
        toggleUserSuspension(
            id: $id,
            correlationId: $correlationId,
            fourEyesUserId: $fourEyesUserId, 
            fourEyesPassword: $fourEyesPassword, 
            extraConfirmation: $extraConfirmation
        ) {
            racf
            name
            suspended
        }
    }
`;

export const TOGGLE_USER_ACTIVATION = gql`
    mutation ToggleUserActivation(
        $id: Int!,
        $correlationId: String!
    ) {
        toggleUserActivation(
            id: $id,
            correlationId: $correlationId
        ) {
            racf
            name
            active
        }
    }
`;

export const ON_USER_CHANGED = gql`
    subscription onUserChanged {
        userChanged {
            correlationId
            action
            model {
                racf
                name
            }
        }
    }
`;
